module.exports = __webpack_public_path__ + "static/media/routefinder-menu-item.3055471a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/routefinder-menu-item.svg
// module id = 175
// module chunks = 0